import axios from "axios";

export const getServerURL = () => {
  const staging = "https://ecomm-api.cloudxier.dev"
  const localhost = "http://localhost:3123"
  const production = "https://beststg.cloudxier.com"
  // Get host from here
  let host = window.location.host;
  if (host) {
    host = host.toLowerCase();
  }
  let env
  switch (host) {
    case "ecomm-stg.cloudxier.dev":
      env = staging
      break;
    case "ecommerce.maplexxon.com":
      env = production
      break;
    default:
      env = localhost
  }
  return env
}

const Axios = axios.create({
  baseURL: getServerURL(),
  withCredentials: true
});

export default Axios;
